<div class="pointsContainer">
  <div class="pointPart pointPartText tableWrapper">
    <div class="tableHeader">
      <h1>{{ 'List' | translate }}</h1>
      <div class="headerBtns">
        <div class="add-sample-form">
          <!-- <input matInput placeholder="{{ 'Search' | translate }}" (input)="applyFilter($event)" /> -->
          <h2 (click)="goToNewVendor()" *ngIf="vendor.canAddMoreVendors()" [style.cursor]="vendor.canAddMoreVendors() ? 'pointer' : 'not-allowed'">
            {{ '+ ADD NEW VENDOR' | translate }}
          </h2>
          <p *ngIf="!vendor.canAddMoreVendors()" class="limitWarning">You have reached the maximum of {{ vendor.vendorLimitState.value }} vendors.</p>
          <input matInput placeholder="{{ 'Name, Email, ID, Status' | translate }}" (input)="applyFilter($event)" />
          <!-- <button class="addButton">{{ 'Search Vendor' | translate }}</button> -->
        </div>
      </div>
    </div>

    <!-- Table to Display Vendor -->
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 userTable" matSort>
      <ng-container matColumnDef="img">
        <th mat-header-cell *matHeaderCellDef>{{ 'Image' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <img [src]="element.img !== 'demo_app_icon.png' ? element.img : 'assets/images/empty-image.png'" [alt]="'App Icon' | translate" />
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'Store Name' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'Email' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>
      <!-- ✅ Vendor ID column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{ 'Vendor ID' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="creationDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'Registration Date' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.creationDate }}</td>
      </ng-container>

      <ng-container matColumnDef="activation">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'Status' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle [checked]="element.activation" (change)="toggleActivation(element)"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          <span class="material-icons material-symbols-outlined editicon" (click)="navigateToVendor(row.id)">visibility</span>
          <span class="material-icons material-icons-outlined deleteIcon" (click)="deleteVendor(row)">delete</span>
        </td>

      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons aria-label="Select page of periodic data"></mat-paginator>
  </div>
</div>
